import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-quote-icon',
	templateUrl: './quote-icon.component.html',
})
export class QuoteIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary_s50';

	constructor() {}
}
